import { Injectable } from '@angular/core';
import { Directory } from '../interfaces/directory.interface';
import { BehaviorSubject } from 'rxjs';

export const ROOT_DIRECTORY: Directory = {
    id: 'root',
    name: 'Principal',
    parentId: undefined,
    shareable: true,
    tenantId: '',
    hasChildren: true
};


@Injectable({
    providedIn: 'root'
})
export class NavigationService {
    private readonly stack$ = new BehaviorSubject<Directory[]>([ROOT_DIRECTORY]);
    readonly navigation$ = this.stack$.asObservable();

    get current(): Directory | null {
        const stack = this.stack$.value;
        return stack.length ? stack[stack.length - 1] : null;
    }

    setRoot(directory: Directory) {
        this.stack$.next([directory]);
    }

    goToRoot() {
        this.stack$.next([ROOT_DIRECTORY]);
    }


    push(directory: Directory) {
        const stack = this.stack$.value;

        // evita duplicar
        if (stack.length && stack[stack.length - 1].id === directory.id) {
            return;
        }

        this.stack$.next([...stack, directory]);
    }

    pop() {
        const stack = this.stack$.value;
        if (stack.length <= 1) {
            this.stack$.next([]);
            return null;
        }

        const newStack = stack.slice(0, -1);
        this.stack$.next(newStack);
        return newStack[newStack.length - 1];
    }

    navigateTo(directoryId: string) {
        const stack = this.stack$.value;
        const index = stack.findIndex(d => d.id === directoryId);

        if (index !== -1) {
            this.stack$.next(stack.slice(0, index + 1));
        }
    }

    clear() {
        this.stack$.next([]);
    }
}
